import React, { Component } from 'react';
import PropTypes from 'prop-types';

class Checkbox extends Component {
  state = {
      isChecked: false,
      isHover: false,
  }

  toggleCheckboxChange = () => {
      const { handleCheckboxChange, value, name } = this.props;

      this.setState(({ isChecked }) => ({
          isChecked: !isChecked,
      }));

      handleCheckboxChange(value, name);
  }

  render() {

    const { label, value, select_option, type = '' } = this.props;
    const isChecked = select_option.has(value)

    let clases = '';

    if (type === 'radio') {
      clases = 'rounded-circle'
    }
    
    return (
      <>
      <div className={`checkbox pl-3 py-3 d-flex align-items-start item-${value} ${(isChecked? 'active' :'')}`}>
        <input className='mr-3' type="checkbox" id={value} value={value} checked={isChecked} onChange={this.toggleCheckboxChange} autoComplete="off"/>
        <i className={`icon-check mt-3 ml-3 ${clases}`}></i>
        {label && 
          <label className='mb-0 pr-3' htmlFor={value}>{label}</label>
        }
      </div>
      </>
    );
  }
}

Checkbox.propTypes = {
  handleCheckboxChange: PropTypes.func.isRequired,
};

export default Checkbox;
